import { Component, OnInit } from '@angular/core';

//export interface PeriodicElement {
//  employerName: string;
//  contact: string;
//  hireDate: string;
//  startDate: string;
//  endDate: string;
//  status: string;
//}

//const ELEMENT_DATA: PeriodicElement[] = [
//  { employerName: 'Olivia Rhye', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//  { employerName: 'Lana Steiner', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//  { employerName: 'Natali Craig', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//  { employerName: 'Drew Cano', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//  { employerName: 'Orlando Diggs', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//  { employerName: 'Andi Lane', contact: '(214) 999-6565', hireDate: '03/05/2023', startDate: '04/19/2024', endDate: '04/19/2024', status: 'Active' },
//];

@Component({
  selector: 'app-employers',
  templateUrl: './employers.component.html',
  styleUrls: ['./employers.component.scss']
})
export class EmployersComponent implements OnInit {

  //displayedColumns: string[] = ['employerName', 'contact', 'hireDate', 'startDate', 'endDate', 'status', 'actions'];
  //dataSource = ELEMENT_DATA;
  constructor() { }

  ngOnInit() {
  }

}
